// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--KEL_R","under-construction":"dece2e673c--under-construction--Rqu0M","icon":"dece2e673c--icon--wI8yP"};